module.exports = __webpack_public_path__ + "img/yj_2.0b0bfe55.png";